module.exports = __webpack_public_path__ + "img/news-cover-placeholder.9e04dc05.png";